import axios from 'axios'

export const community = {
  state: {
      token: localStorage.getItem("token") || '',
      logindetails: {},
      community: [],
      communityCount: '',
      memberCount: '',
      expiredPremium: '',
      communitybyid: [],
      membersbyid: [],
      viewpolicy: [],
      viewclaims: [],
      members:[]
  },
  mutations:{
      community(state, data){
        state.community = data.communities
      },
      Login(state,token){
        state.token = token
      },
      LoginDetails(state, data){
        state.logindetails = data
      },
      communitybyid(state, data){
        state.communitybyid = data.community  
      },
      membersbyid(state, data){
        state.membersbyid = data.member
      },
      setMembers(state, data){
        state.members = data.members
      },
      viewpolicy(state, data){
        state.viewpolicy =  data.subscription
      },
      viewclaims(state, data){
        state.viewclaims =  data.claim
      },
      communityCount(state,data){
        state.communityCount = data.NumberOfCommunities
      },
      memberCount(state, data){
        state.memberCount = data.NumberOfMembers
      },
      expiredPremium(state, data){
        state.expiredPremium = data.NumberOfExpiredSubscriptions
      },
      policyUpdate(state, data){
        state.membersbyid[0].policyDetails = data.subscriptions
      },
      claims(state, data){
        state.communitybyid.claims= data.claims
      }
  },
  actions:{
      Login: ({commit}, payload) => {
          return new Promise((resolve, reject)=>{
            axios.post("/consultant_auth",payload)
            .then(({data, status})=>{
              if(status === 200){
                const token = data.token
                localStorage.setItem("token", token)
                axios.defaults.headers.common['Authorization'] = token
                commit('Login', token)
                commit('LoginDetails', data)
                resolve(data);
              }
            })
            .catch((error)=>{
              reject(error);
            });
          })
        },
        UpdateImage: ({commit},payload)=>{
          return new Promise((resolve, reject)=>{
            axios.get("/consultants/"+payload)
            .then(({status, data})=>{
              if(status === 200){
                resolve(data)
                commit('LoginDetails', data.consultant[0])
              }
            })
            .catch((error)=>{
              reject(error);
            })
          }); 
        },
      AUTH_LOGOUT: ({commit})=>{
        return new Promise((resolve, reject) => {
          // commit("AUTH_LOGOUT")
          localStorage.removeItem("token")
          // remove the axios default header
          delete axios.defaults.headers.common['Authorization']
          resolve()
        })
        },
      getCommunity: ({commit})=>{
          return new Promise((resolve, reject)=>{
            axios.get("/community")
            .then(({status, data})=>{
              if(status === 200){
                resolve(data);
                commit("community", data)
              }
            })
            .catch((error)=>{
              reject(error);
            });
          })
        },
        addCommunity: ({commit},payload)=>{
          return new Promise((resolve, reject)=>{
            axios.post("/community",payload)
            .then(({data, status})=>{
              if(status === 201){
                resolve(data);
              }
            })
            .catch((error)=>{
              reject(error);
            });
          })
        },
        editCommunity: ({commit},payload)=>{
          return new Promise((resolve, reject)=>{
            axios.put("/community",payload)
            .then(({data, status})=>{
              if(status === 200){
                resolve(data);
              }
            })
            .catch((error)=>{
              reject(error);
            });
          })
        },
        getCommunityCount :({commit}) =>{
          return new Promise((resolve, reject)=>{
            axios.get("/community/count/communityCount")
            .then(({status, data})=>{
              if(status === 200){
                resolve(data);
                commit("communityCount", data)
              }
            })
            .catch((error)=>{
              reject(error);
            });
          })
        },
      getExpiredPremiums: ({commit})=>{
        return new Promise((resolve, reject)=>{
          axios.get("/subscriptions/count/expiredSubscriptions")
          .then(({status, data})=>{
            if(status === 200){
              resolve(data);
              commit("expiredPremium", data)
            }
          })
          .catch((error)=>{
            reject(error);
          });
        })

        },
      getMembersCount: ({commit}) =>{
        return new Promise((resolve, reject)=>{
          axios.get("/members/count/memberCount")
          .then(({status, data})=>{
            if(status === 200){
              resolve(data);
              commit("memberCount", data)
            }
          })
          .catch((error)=>{
            reject(error);
          });
        })
      },
      CommunityById: ({commit},payload)=>{
          return new Promise((resolve, reject)=>{
              axios.get("/community/"+payload)
              .then(({status, data})=>{
                if(status === 200){
                  resolve(data)
                  commit('communitybyid', data)
                }
              })
              .catch((error)=>{
                reject(error);
              })
            });      
      },
      MembersById: ({commit},payload)=>{
          return new Promise((resolve, reject)=>{
              axios.get("/members/"+payload)
              .then(({status, data})=>{
                if(status === 200){
                  resolve(data)
                  commit('membersbyid', data)
                }
              })
              .catch((error)=>{
                reject(error);
              })
            }); 
      },
      getMembers: ({commit})=>{
        return new Promise((resolve, reject)=>{
          axios.get("/members")
          .then(({status, data})=>{
            if(status === 200){
              resolve(data)
              commit('setMembers', data)
            }
          })
          .catch((error)=>{
            reject(error);
          })
        }); 
      },
      getMembersFilter: ({commit},payload)=>{
        return new Promise((resolve, reject)=>{
            axios.get(`/members?status=${payload.status}`)
            .then(({status, data})=>{
              if(status === 200){
                resolve(data)
                commit('setMembers', data)
              }
            })
            .catch((error)=>{
              reject(error);
            })
          }); 
      },
      ViewPolicy: ({commit},payload)=>{
          return new Promise((resolve, reject)=>{
              axios.get("/subscriptions/"+payload)
              .then(({status, data})=>{
                if(status === 200){
                  resolve(data)
                  commit('viewpolicy', data)
                }
              })
              .catch((error)=>{
                reject(error);
              })
            });
      },
      // get policies with filters
        getPolicyFilters: ({commit}, payload)=>{
          return new Promise((resolve, reject)=>{
            axios.get(`/subscriptions?username=${payload.username}&isActive=${payload.isActive}`)
            .then(({status, data})=>{
              if(status === 200){
                resolve(data);
                commit("policyUpdate", data)
              }
            })
            .catch((error)=>{
              reject(error);
            });
          })
        },
        // get policies with filters
        getPolicyOneFilter: ({commit}, payload)=>{
        return new Promise((resolve, reject)=>{
          axios.get(`/subscriptions?username=${payload.username}`)
          .then(({status, data})=>{
            if(status === 200){
              resolve(data);
              commit("policyUpdate", data)
            }
          })
          .catch((error)=>{
            reject(error);
          });
        })
      },
      ViewClaim: ({commit},payload)=>{
          return new Promise((resolve, reject)=>{
              axios.get("/claims/"+payload)
              .then(({status, data})=>{
                if(status === 200){
                  resolve(data)
                  commit('viewclaims', data)
                }
              })
              .catch((error)=>{
                reject(error);
              })
            });
      },
      ClaimsFilter: ({commit}, payload)=>{
        return new Promise((resolve, reject)=>{
          axios.get(`/claims?status=${payload.status}&communityCode=${payload.communityCode}`)
          .then(({status, data})=>{
            if(status === 200){
              resolve(data);
              commit("claims", data)
            }
          })
          .catch((error)=>{
            reject(error);
          });
      })
    },
    ClaimsFilterAll: ({commit}, payload)=>{
      return new Promise((resolve, reject)=>{
        axios.get(`/claims?communityCode=${payload.communityCode}`)
        .then(({status, data})=>{
          if(status === 200){
            resolve(data);
            commit("claims", data)
          }
        })
        .catch((error)=>{
          reject(error);
        });
    })
  },
  },
}